export type BriefingTopic = {
  id: string
  title: string
  icon: string
  route: string
  permission: string
}

const topicDefinitions = [
  {id: 'cancelamento-encerramento', title: 'Cancelamento / Encerramento'},
  {id: 'reativacao', title: 'Reativação'},
  {id: 'alteracao-budget', title: 'Alteração budget'},
  {id: 'budget-atrelado', title: 'Budget atrelado'},
  {id: 'alteracao-cnpj', title: 'Alteração CNPJ'},
  {id: 'alteracao-segmento', title: 'Alteração de Segmento na Promoção'},
  {id: 'alteracao-ean', title: 'Alteração EAN'},
  {id: 'troca-familia', title: 'Troca de família'},
  {id: 'alteracao-seller', title: 'Alteração Seller'},
  {id: 'alteracao-vigencia', title: 'Alteração vigência'},
  {id: 'criacao-segmentacao-recorrente', title: 'Criação de nova segmentação recorrente'},
  {id: 'criacao-segmentacao-recompra', title: 'Criação de segmentação de recompra'},
  {id: 'criacao-familia', title: 'Criação de família'},
  {id: 'alteracao-desconto', title: 'Alteração de desconto'},
  {id: 'alteracao-valor-minimo-maximo', title: 'Alteração Valor Mínimo e Máximo'},
  {id: 'alteracao-quantidade-minima-maxima', title: 'Alteração quantidade mínima e máxima'},
  {id: 'alteracao-outros-campos', title: 'Alteração outros campos'},
  {id: 'alteracao-icone-lista-sugerida', title: 'Alteração ícone lista sugerida'},
]

export const briefingTopics: BriefingTopic[] = topicDefinitions.map((topic) => ({
  ...topic,
  icon: '/media/icons/duotune/menu/briefing-topics/' + topic.id + '.svg',
  route: '/briefing-promocoes/topicos/' + topic.id,
  permission: 'briefing-promocoes-topicos-' + topic.id + '-view',
}))

export function getAvailableBriefingTopics(permissions: readonly {name: string}[]) {
  const permissionNames = new Set(permissions.map((permission) => permission.name))
  return briefingTopics.filter((topic) => permissionNames.has(topic.permission))
}
